$(() => {
  let modal = $('#js-forced-modal')
  if (!modal.length) {
    return
  }

  let body = $('#js-forced-modal-body')
  let submit = $('#js-forced-modal-submit')
  let submitTooltip = $('#js-forced-modal-submit-tooltip')
  let checkbox = $('#js-forced-modal-checkbox')
  let el = body.get(0)
  // 一度でも最後までスクロールしたら、以後スクロール位置が戻ってもボタンは有効のまま保つ
  let hasScrolledToBottom = false

  let isScrolledToBottom = () => el.scrollHeight - el.scrollTop - el.clientHeight < 10
  let isCheckboxOk = () => !checkbox.length || checkbox.prop('checked')

  let updateSubmitState = () => {
    if (isScrolledToBottom()) {
      hasScrolledToBottom = true
    }
    submit.prop('disabled', !(hasScrolledToBottom && isCheckboxOk()))
    submitTooltip.tooltip(hasScrolledToBottom ? 'disable' : 'enable')
  }

  // コンテンツがそもそもスクロール不要な高さの場合は最初から押せるようにする
  // (表示アニメーション完了前は高さが正しく取得できないため、表示後に判定する)
  modal.on('shown.bs.modal', () => {
    updateSubmitState()
  })

  modal.modal({ backdrop: 'static', keyboard: false })
  modal.modal('show')

  body.on('scroll', () => {
    updateSubmitState()
  })

  checkbox.on('change', () => {
    updateSubmitState()
  })
})
